 function applySearchResultsARIA() {
  // Select earch container
  const resultsContainer = document.querySelector('.search-flydown--results.visible');
  
  // Apply att ARIA if exist
  if (resultsContainer && !resultsContainer.hasAttribute('aria-live')) {
    resultsContainer.setAttribute('aria-live', 'polite');
    resultsContainer.setAttribute('aria-atomic', 'false');
    resultsContainer.setAttribute('aria-relevant', 'additions text');
    resultsContainer.setAttribute('role', 'region');
    resultsContainer.setAttribute('aria-label', 'Search results');
  }
}

// Observer  detect when load component search
const searchObserver = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.addedNodes.length) {
      applySearchResultsARIA();
    }
  });
});

// Init observer when  DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    // Aplply if exist
    applySearchResultsARIA();
    // Observ changes futures
    searchObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
} else {
  // DOM ready
  applySearchResultsARIA();
  searchObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
}




// Add link announcement into


document.addEventListener('DOMContentLoaded', function() {
  const link = document.querySelector('.announcement-bar-link');
  const text = document.querySelector('.announcement-bar-text');
  const mobileText = document.querySelector('.announcement-bar-text-mobile');
  
  if (link && text && mobileText) {
    // Move  elements into link
    link.appendChild(text);
    link.appendChild(mobileText);
    
    link.classList.add('announcement-bar-text-container');
  }
});

//highlight banner link 
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.highlights-banner__block.highlights-banner__align-center').forEach(block => {
    const link = block.querySelector('.highlights-banner__block-link');
    if (!link) return;
    
    // Move all content 
    Array.from(block.childNodes).forEach(child => {
      if (child !== link) {
        link.appendChild(child.cloneNode(true));
      }
    });
    
    // Limpiamos el bloque original y movemos el enlace (que ahora contiene todo)
    block.innerHTML = '';
    block.appendChild(link);
  });
});


// tab datepicker
/* document.addEventListener('DOMContentLoaded', function() {
  const dateInput = document.getElementById('ml_ship_date');
  const checkoutButton = document.querySelector('button[name="checkout"]');
  
  if (!dateInput || !checkoutButton) return;

  let datepickerVisible = false;
  let ignoreHide = false;

  $(dateInput).datepicker({
    beforeShow: function() {
      datepickerVisible = true;
      ignoreHide = true;
      setTimeout(() => { ignoreHide = false; }, 100);
      return {};
    },
    onClose: function() {
      datepickerVisible = false;
    },
    onSelect: function() {
      $(this).datepicker('hide');
    }
  });

  function positionDatepicker() {
    const datepicker = document.getElementById('ui-datepicker-div');
    if (!datepicker) return;

    datepicker.style.position = 'absolute';
    datepicker.style.top = 'auto';
    datepicker.style.left = 'auto';
    datepicker.style.zIndex = '1000';
    dateInput.parentNode.insertBefore(datepicker, dateInput.nextSibling);
  }

  dateInput.addEventListener('focus', function() {
    if (!datepickerVisible) {
      $(dateInput).datepicker('show');
      setTimeout(positionDatepicker, 50);
    }
  });

  dateInput.addEventListener('blur', function(e) {
    if (ignoreHide) return;
    
    setTimeout(() => {
      const datepicker = document.getElementById('ui-datepicker-div');
      if (datepicker && datepickerVisible) {
        const focused = document.activeElement;
        if (!datepicker.contains(focused) {
          $(dateInput).datepicker('hide');
        }
      }
    }, 10);
  });

  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Tab' || !datepickerVisible) return;
    
    const datepicker = document.getElementById('ui-datepicker-div');
    if (!datepicker) return;

    const focusableElements = datepicker.querySelectorAll(
      'a[data-handler], .ui-datepicker-prev, .ui-datepicker-next'
    );
    
    if (focusableElements.length === 0) return;

    const firstFocusable = focusableElements[0];
    const lastFocusable = focusableElements[focusableElements.length - 1];

    if (e.shiftKey && document.activeElement === firstFocusable) {
      e.preventDefault();
      dateInput.focus();
    } else if (!e.shiftKey && document.activeElement === lastFocusable) {
      e.preventDefault();
      checkoutButton.focus();
    }
  });

  document.addEventListener('click', function(e) {
    if (datepickerVisible && 
        e.target !== dateInput && 
        !e.target.closest('#ui-datepicker-div')) {
      $(dateInput).datepicker('hide');
    }
  });
});

const style = document.createElement('style');
style.textContent = `
  #ui-datepicker-div {
    position: absolute !important;
    top: auto !important;
    left: auto !important;
    z-index: 1000 !important;
  }
  .ui-datepicker {
    margin-top: 5px !important;
  }
`;
document.head.appendChild(style);

*/


/* document.addEventListener('DOMContentLoaded', function() {
  // 1. Esperar a que Flickity cargue (usando MutationObserver)
  console.log("ejecutando slider Flickity");
  const observer = new MutationObserver(function(mutations, obs) {
    const dots = document.querySelectorAll('.flickity-page-dots .dot');
    const slides = document.querySelectorAll('.testimonial');
    
    if (dots.length > 0 && slides.length > 0) {
      obs.disconnect(); // Dejar de observar

      // 2. Corregir atributos ARIA en dots
      dots.forEach((dot, index) => {
        // Asignar roles y propiedades ARIA
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-controls', `testimonial-${index + 1}`);
        dot.setAttribute('aria-label', `Go to testimonial ${index + 1} of ${dots.length}`);
        
        // Solo el dot seleccionado debe ser enfocable
        dot.tabIndex = dot.classList.contains('is-selected') ? 0 : -1;
      });

      // 3. Corregir atributos ARIA en slides
      slides.forEach((slide, index) => {
        slide.id = `testimonial-${index + 1}`;
        slide.setAttribute('role', 'tabpanel');
        slide.setAttribute('aria-labelledby', `dot-${index + 1}`);
      });

      // 4. Manejar eventos de teclado en dots
      dots.forEach((dot, index) => {
        dot.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            moveToSlide(index);
          }
        });

        dot.addEventListener('click', () => moveToSlide(index));
      });

      // 5. Sincronizar cambios de Flickity con ARIA
      const flkty = Flickity.data(carousel);
      flkty.on('change', (index) => {
        updateAriaStates(index);
      });
    }
  });

  // Observar cambios en el DOM
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Funciones auxiliares
  function moveToSlide(index) {
    const flkty = Flickity.data('.testimonials');
    flkty.select(index);
    updateAriaStates(index);
  }

  function updateAriaStates(selectedIndex) {
    const dots = document.querySelectorAll('.flickity-page-dots .dot');
    const slides = document.querySelectorAll('.testimonial');
    
    dots.forEach((dot, index) => {
      const isSelected = index === selectedIndex;
      dot.setAttribute('aria-selected', isSelected);
      dot.setAttribute('tabindex', isSelected ? '0' : '-1');
      dot.classList.toggle('is-selected', isSelected);
    });

    slides.forEach((slide, index) => {
      slide.hidden = index !== selectedIndex;
      slide.setAttribute('aria-hidden', index !== selectedIndex);
    });
  }
}); */

document.addEventListener('DOMContentLoaded', function () {
  console.log("Ejecutando slider Flickity (accesibilidad)");

  let maxAttempts = 20;
  let attempt = 0;

  const intervalCheck = setInterval(() => {
    const carousel = document.querySelector('.testimonials');
    const dots = document.querySelectorAll('.flickity-page-dots .dot');
    const slides = document.querySelectorAll('.testimonial');

    if (carousel && dots.length > 0 && slides.length > 0) {
      clearInterval(intervalCheck);
      enhanceFlickityAccessibility(carousel, dots, slides);
    }

    attempt++;
    if (attempt > maxAttempts) {
      clearInterval(intervalCheck);
      console.warn("Flickity elements not found after max attempts.");
    }
  }, 300);

  function enhanceFlickityAccessibility(carousel, dots, slides) {
    dots.forEach((dot, index) => {
      dot.setAttribute('role', 'tab');
      dot.setAttribute('id', `dot-${index + 1}`);
      dot.setAttribute('aria-controls', `testimonial-${index + 1}`);
      dot.setAttribute('aria-label', `Go to testimonial ${index + 1} of ${dots.length}`);
      dot.setAttribute('aria-selected', dot.classList.contains('is-selected'));
      dot.tabIndex = dot.classList.contains('is-selected') ? 0 : -1;

      dot.tabIndex = 0;

      dot.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          moveToSlide(index);
        }
      });

      dot.addEventListener('click', () => moveToSlide(index));
    });

    slides.forEach((slide, index) => {
      slide.id = `testimonial-${index + 1}`;
      slide.setAttribute('role', 'tabpanel');
      slide.setAttribute('aria-labelledby', `dot-${index + 1}`);
      slide.hidden = !dots[index].classList.contains('is-selected');
      slide.setAttribute('aria-hidden', !dots[index].classList.contains('is-selected'));
    });

    const flkty = Flickity.data(carousel);
    if (flkty) {
      flkty.on('change', (index) => {
        updateAriaStates(index, dots, slides);
      });
    }
  }

  function moveToSlide(index) {
    const flkty = Flickity.data('.testimonials');
    if (flkty) {
      flkty.select(index);
      const dots = document.querySelectorAll('.flickity-page-dots .dot');
      const slides = document.querySelectorAll('.testimonial');
      updateAriaStates(index, dots, slides);
    }
  }

  function updateAriaStates(selectedIndex, dots, slides) {
    dots.forEach((dot, index) => {
      const isSelected = index === selectedIndex;
      dot.setAttribute('aria-selected', isSelected);
      dot.setAttribute('tabindex', isSelected ? '0' : '-1');
      dot.classList.toggle('is-selected', isSelected);
    });

    slides.forEach((slide, index) => {
      const isActive = index === selectedIndex;
      slide.hidden = !isActive;
      slide.setAttribute('aria-hidden', !isActive);
    });
  }
});




// Autofocus checkout 
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    const cartLink = document.getElementById('cart-link');
    const emailField = document.getElementById('email');
    
    if (cartLink && emailField) {
      emailField.removeAttribute('autofocus');
    }
  }, 1000); 
});




// Select all h2 elements with class 'productitem--title' and replace them with h3
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    document.querySelectorAll('.productitem--title').forEach(title => {
      title.outerHTML = title.outerHTML.replace(/^<h2/, '<h3').replace(/h2>$/, 'h3>');
    });
  }, 1000);
});




//navegation arrows in submenu
/* function initAccessibleNavMenu() {
  console.log("Running: Accessible nav menu setup");

  // =============================
  // Setup ARIA attributes
  // =============================
  const menuContainers = document.querySelectorAll('.navmenu-item-parent');

  menuContainers.forEach((container) => {
    const summary = container.querySelector('summary');
    const submenu = container.querySelector('ul[role="menu"]');

    if (summary && submenu) {
      summary.setAttribute('role', 'menuitem');
      summary.setAttribute('aria-haspopup', 'true');
      summary.setAttribute('aria-expanded', container.querySelector('details')?.open ? 'true' : 'false');
      submenu.setAttribute('role', 'menu');

      const links = submenu.querySelectorAll('.navmenu-link');
      links.forEach(link => {
        link.setAttribute('role', 'menuitem');
        link.setAttribute('tabindex', '-1');
      });
    }
  });

  // =============================
  // Keyboard Navigation
  // =============================
  document.addEventListener('keydown', function (event) {
    const focused = document.activeElement;
    if (!focused.matches('[role="menuitem"]')) return;

    const parentMenu = focused.closest('[role="menu"], [role="menubar"]');
    const items = Array.from(parentMenu.querySelectorAll('[role="menuitem"]'));
    const currentIndex = items.indexOf(focused);
    let next;

    switch (event.key) {
      case 'ArrowDown':
        console.log('⬇️ ArrowDown pressed');
        event.preventDefault();
        next = items[currentIndex + 1] || items[0];
        moveFocus(focused, next);
        break;
    
      case 'ArrowUp':
        console.log('⬆️ ArrowUp pressed');
        event.preventDefault();
        next = items[currentIndex - 1] || items[items.length - 1];
        moveFocus(focused, next);
        break;
    
      case 'ArrowRight':
        console.log('➡️ ArrowRight pressed');
        event.preventDefault();
        if (focused.tagName === 'SUMMARY') {
          const details = focused.parentElement;
          const submenu = details.querySelector('[role="menu"]');
          if (submenu) {
            details.open = true;
            focused.setAttribute('aria-expanded', 'true');
            const first = submenu.querySelector('[role="menuitem"]');
            if (first) moveFocus(focused, first);
          }
        }
        break;
    
      case 'ArrowLeft':
        console.log('⬅️ ArrowLeft pressed');
        event.preventDefault();
        const parentDetails = focused.closest('ul[role="menu"]')?.closest('details');
        if (parentDetails) {
          parentDetails.open = false;
          const summary = parentDetails.querySelector('summary');
          if (summary) moveFocus(focused, summary);
        }
        break;
    
      case 'Enter':
        console.log('⏎ Enter pressed');
        if (focused.tagName === 'SUMMARY') {
          event.preventDefault();
          const details = focused.closest('details');
          const isOpen = details.open;
    
          if (!isOpen) {
            details.open = true;
            focused.setAttribute('aria-expanded', 'true');
    
            const submenu = details.querySelector('[role="menu"]');
            const firstItem = submenu?.querySelector('[role="menuitem"]');
            if (firstItem) {
              moveFocus(focused, firstItem);
            }
          }
        }
        break;
    
      case ' ':
        if (focused.tagName === 'SUMMARY') {
          console.log('␣ Space pressed on summary');
          event.preventDefault(); // Previene comportamiento nativo
      
          const details = focused.closest('details');
          const isOpen = details.open;
      
          if (!isOpen) {
            console.log('Opening submenu');
            details.open = true;
            focused.setAttribute('aria-expanded', 'true');
      
            const submenu = details.querySelector('[role="menu"]');
            const firstItem = submenu?.querySelector('[role="menuitem"]');
            if (firstItem) {
              moveFocus(focused, firstItem); // Opcional
            }
          } else {
            console.log('Submenu already open. No action taken.');
            // No hacer nada
          }
        break;
    
      case 'Escape':
        console.log('⎋ Escape pressed');
        const openDetails = focused.closest('ul[role="menu"]')?.closest('details');
        if (openDetails) {
          openDetails.open = false;
          const summary = openDetails.querySelector('summary');
          if (summary) summary.focus();
        }
        break;
    }

  });

  // =============================
  // Update aria-expanded on click
  // =============================
  document.querySelectorAll('summary[aria-haspopup="true"]').forEach(summary => {
    summary.addEventListener('click', () => {
      const details = summary.closest('details');
      const isOpen = details.open;
      summary.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  });

  // =============================
  // Utility: focus change
  // =============================
  function moveFocus(from, to) {
    if (!to) return;
    from.setAttribute('tabindex', '-1');
    to.setAttribute('tabindex', '0');
    to.focus();
  }
} */

// Run the function when DOM is ready
/* document.addEventListener('DOMContentLoaded', initAccessibleNavMenu); */

function initAccessibleNavMenu() {
  console.log("Running: Accessible nav menu setup");

  // =============================
  // Setup ARIA attributes
  // =============================
  const menuContainers = document.querySelectorAll('.navmenu-item-parent');

  menuContainers.forEach((container) => {
    const summary = container.querySelector('summary');
    const submenu = container.querySelector('ul[role="menu"]');

    if (summary && submenu) {
      summary.setAttribute('role', 'menuitem');
      summary.setAttribute('aria-haspopup', 'true');
      summary.setAttribute('aria-expanded', container.querySelector('details')?.open ? 'true' : 'false');
      submenu.setAttribute('role', 'menu');

      const links = submenu.querySelectorAll('.navmenu-link');
      links.forEach(link => {
        link.setAttribute('role', 'menuitem');
        link.setAttribute('tabindex', '-1');
      });
    }
  });

  // =============================
  // Keyboard handlers map
  // =============================
  const keyHandlers = {
    ArrowDown(event, focused, items, currentIndex) {
      console.log('⬇️ ArrowDown pressed');
      event.preventDefault();
      const next = items[currentIndex + 1] || items[0];
      moveFocus(focused, next);
    },

    ArrowUp(event, focused, items, currentIndex) {
      console.log('⬆️ ArrowUp pressed');
      event.preventDefault();
      const next = items[currentIndex - 1] || items[items.length - 1];
      moveFocus(focused, next);
    },

    ArrowRight(event, focused) {
      console.log('➡️ ArrowRight pressed');
      event.preventDefault();
      if (focused.tagName === 'SUMMARY') {
        const details = focused.parentElement;
        const submenu = details.querySelector('[role="menu"]');
        if (submenu) {
          details.open = true;
          focused.setAttribute('aria-expanded', 'true');
          const first = submenu.querySelector('[role="menuitem"]');
          if (first) moveFocus(focused, first);
        }
      }
    },

    ArrowLeft(event, focused) {
      console.log('⬅️ ArrowLeft pressed');
      event.preventDefault();
      const parentDetails = focused.closest('ul[role="menu"]')?.closest('details');
      if (parentDetails) {
        parentDetails.open = false;
        const summary = parentDetails.querySelector('summary');
        if (summary) moveFocus(focused, summary);
      }
    },

    Enter(event, focused) {
      console.log('⏎ Enter pressed');
      if (focused.tagName === 'SUMMARY') {
        event.preventDefault();
        const details = focused.closest('details');
        const isOpen = details.open;

        if (!isOpen) {
          details.open = true;
          focused.setAttribute('aria-expanded', 'true');

          const submenu = details.querySelector('[role="menu"]');
          const firstItem = submenu?.querySelector('[role="menuitem"]');
          if (firstItem) moveFocus(focused, firstItem);
        } else {
          console.log('Submenu already open. No action taken.');
        }
      }
    },

    Space(event, focused) {
      console.log('␣ Space pressed');
      if (focused.tagName === 'SUMMARY') {
        event.preventDefault();
        const details = focused.closest('details');
        const isOpen = details.open;

        if (!isOpen) {
          console.log('Opening submenu');
          details.open = true;
          focused.setAttribute('aria-expanded', 'true');

          const submenu = details.querySelector('[role="menu"]');
          const firstItem = submenu?.querySelector('[role="menuitem"]');
          if (firstItem) moveFocus(focused, firstItem);
        } else {
          console.log('Submenu already open. No action taken.');
        }
      }
    },

    Escape(event, focused) {
      console.log('⎋ Escape pressed');
      const openDetails = focused.closest('ul[role="menu"]')?.closest('details');
      if (openDetails) {
        openDetails.open = false;
        const summary = openDetails.querySelector('summary');
        if (summary) summary.focus();
      }
    }
  };

  // =============================
  // Keyboard Navigation
  // =============================
  document.addEventListener('keydown', function (event) {
    const focused = document.activeElement;
    if (!focused.matches('[role="menuitem"]')) return;

    const parentMenu = focused.closest('[role="menu"], [role="menubar"]');
    const items = Array.from(parentMenu.querySelectorAll('[role="menuitem"]'));
    const currentIndex = items.indexOf(focused);

    const handlerKey = event.code === 'Space' ? 'Space' : event.key;
    const handler = keyHandlers[handlerKey];

    if (handler) {
      handler(event, focused, items, currentIndex);
    }
  }, true); // capture: true para interceptar comportamiento nativo del summary

  // =============================
  // Update aria-expanded on click
  // =============================
  document.querySelectorAll('summary[aria-haspopup="true"]').forEach(summary => {
    summary.addEventListener('click', () => {
      const details = summary.closest('details');
      const isOpen = details.open;
      summary.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  });

  // =============================
  // Utility: focus change
  // =============================
  function moveFocus(from, to) {
    if (!to) return;
    from.setAttribute('tabindex', '-1');
    to.setAttribute('tabindex', '0');
    to.focus();
  }
}

// Ejecutar al cargar DOM
document.addEventListener('DOMContentLoaded', initAccessibleNavMenu);



// Function to update aria-labels for better screen reader accessibility
function updateProductAriaLabels() {
  const productItems = document.querySelectorAll('li.productgrid--item');
  
  productItems.forEach(productItem => {
    // Get the product name from the title element
    const titleElement = productItem.querySelector('.productitem--title a');
    const productName = titleElement ? titleElement.textContent.trim() : '';
    
    if (productName) {
      // Update aria-label for image link (even if it has tabindex="-1")
      const imageLink = productItem.querySelector('a.productitem--image-link');
      if (imageLink) {
        // Preserve existing tabindex if present
        const currentTabIndex = imageLink.getAttribute('tabindex');
        if (currentTabIndex === '-1') {
          console.log(`Image link for "${productName}" has tabindex="-1" but remains accessible to screen readers`);
        }
        
        // Update aria-label to match product name
        if (imageLink.getAttribute('aria-label') !== productName) {
          imageLink.setAttribute('aria-label', productName);
          console.log(`Updated image link aria-label: "${productName}"`);
        }
      }
      
      // Update aria-label for title link
      if (titleElement && titleElement.getAttribute('aria-label') !== productName) {
        titleElement.setAttribute('aria-label', productName);
        console.log(`Updated title link aria-label: "${productName}"`);
      }
    }
  });
}

// Run initially with a delay to ensure DOM is ready
setTimeout(updateProductAriaLabels, 1000);

// Optional: Run on AJAX content updates (if your site loads products dynamically)
document.addEventListener('DOMContentLoaded', updateProductAriaLabels);
document.addEventListener('ajaxComplete', updateProductAriaLabels); // For Shopify



//Add title to close
document.addEventListener('DOMContentLoaded', function() {
  function updateAriaLabels() {
    const productItems = document.querySelectorAll('.productgrid--item');
    
    if (productItems.length === 0) {
      requestAnimationFrame(updateAriaLabels);
      return;
    }
    
    productItems.forEach(item => {
      const titleElement = item.querySelector('.productitem--title a');
      const closeButton = item.querySelector('.product-recently-viewed-card-remove');
      
      if (titleElement && closeButton) {
        const productTitle = titleElement.textContent.trim();
        closeButton.setAttribute('aria-label', `close ${productTitle}`);
      }
    });
  }
  setTimeout(updateAriaLabels, 1000);
});



//Add Attr autocomplete
document.addEventListener('DOMContentLoaded', function() {
    const zipInput = document.getElementById('address_zip');
    if (zipInput) {
        zipInput.setAttribute('autocomplete', 'postal-code');
    }
});



function addH1Heading() {
  const h2Element = document.querySelector('.slideshow-slide__heading');
  
  if (h2Element && !h2Element.previousElementSibling?.matches('h1')) {
    const h1Element = document.createElement('h1');
    h1Element.textContent = "Discover Everyday Low Prices on Stylish Furniture";
    
    // Añade clases específicas (personaliza según necesites)
    h1Element.classList.add('slideshow-main-title', 'heading-xl');
    
    // Inserta antes del h2
    h2Element.parentNode.insertBefore(h1Element, h2Element);
    
    console.log('h1 añadido correctamente'); // Para depuración
  }
}

// Intenta ejecutarlo al cargar la página
document.addEventListener('DOMContentLoaded', addH1Heading);






//Dot

document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    const dotsContainer = document.querySelector('.flickity-page-dots');
    
    if (!dotsContainer) return;
    
    dotsContainer.setAttribute('role', 'tablist');
    dotsContainer.setAttribute('aria-label', 'Testimonial Navigation');
    
    const dots = document.querySelectorAll('.flickity-page-dots .dot');
    
    dots.forEach((dot, index) => {
      dot.setAttribute('tabindex', '0');
      dot.setAttribute('role', 'tab');
      
      const totalSlides = dots.length;
      dot.setAttribute('aria-label', `Got to ${index + 1} of ${totalSlides}`);
      
      dot.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          const nextDot = this.nextElementSibling || dots[0];
          nextDot.focus();
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          const prevDot = this.previousElementSibling || dots[dots.length - 1];
          prevDot.focus();
        }
      });
      
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName === 'class') {
            const isSelected = dot.classList.contains('is-selected');
            dot.setAttribute('aria-selected', isSelected ? 'true' : 'false');
          }
        });
      });
      
      observer.observe(dot, { attributes: true });
    });
    
    dots.forEach(dot => {
      const isSelected = dot.classList.contains('is-selected');
      dot.setAttribute('aria-selected', isSelected ? 'true' : 'false');
    });
    
  }, 500); 
});







// accesibility  selector de sorting
document.addEventListener('DOMContentLoaded', function() {
  const sortSelect = document.getElementById('product_grid_sort');
  const sortButton = document.querySelector('[data-productgrid-modal-sort]');
  
  if (sortSelect && sortButton) {
    sortButton.setAttribute('tabindex', '0');
    sortButton.removeAttribute('aria-hidden');
    
    sortButton.addEventListener('click', function() {
      sortSelect.focus();
    });
    
    sortButton.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        sortSelect.focus();
      }
    });
    
    sortSelect.addEventListener('change', function() {
      const selectedOption = this.options[this.selectedIndex].text;
      const filterText = sortButton.querySelector('.utils-filter-text');
      if (filterText) {
        filterText.textContent = `Sort by: ${selectedOption}`;
      }
    });
  }
});



 // pagination
document.addEventListener('DOMContentLoaded', function() {
 
  const paginationContainer = document.querySelector('.pagination--container');
  
  if (paginationContainer) {
    const paginationItems = paginationContainer.querySelectorAll('a.pagination--item, li.pagination--active span.pagination--item');
    
    paginationItems.forEach((item, index) => {
      if (!item.hasAttribute('tabindex')) {
        item.setAttribute('tabindex', '0');
      }
      
      item.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (this.tagName === 'A') {
            window.location.href = this.getAttribute('href');
          }
        }
        
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          const nextItem = paginationItems[index + 1];
          if (nextItem) nextItem.focus();
        }
        
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          const prevItem = paginationItems[index - 1];
          if (prevItem) prevItem.focus();
        }
        
        if (e.key === 'Home') {
          e.preventDefault();
          paginationItems[0].focus();
        }
        
        if (e.key === 'End') {
          e.preventDefault();
          paginationItems[paginationItems.length - 1].focus();
        }
      });
    });
    
    const activeItem = paginationContainer.querySelector('.pagination--active');
    if (activeItem) {
      activeItem.setAttribute('aria-current', 'page');
    }
  }
});



//Aria label search mobile
document.addEventListener('DOMContentLoaded', function() {
const observer = new MutationObserver(function(mutations) {
  const mobileSearchButton = document.querySelector('.site-header-mobile-search-button');
  
  if (mobileSearchButton && !mobileSearchButton.hasAttribute('aria-label')) {
    mobileSearchButton.setAttribute('aria-label', 'Search');
    observer.disconnect();
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});
  });





//Add focus filter and key
// Función principal que aplica la accesibilidad
function initSidebarAccessibility() {
  const accordionButtons = document.querySelectorAll('[data-filter-group-trigger]');

  accordionButtons.forEach(button => {
    // Configuración inicial de accesibilidad
    button.setAttribute('role', 'button');
    const isExpanded = button.classList.contains('productgrid--sidebar-button-active');
    button.setAttribute('aria-expanded', isExpanded);
    button.tabIndex = 0;

    // Deshabilitar foco en elementos hijos
    const focusableChildren = button.querySelectorAll('[tabindex]');
    focusableChildren.forEach(child => child.tabIndex = -1);

    // Manejar eventos de teclado
    button.addEventListener('keydown', function(e) {
      switch(e.key) {
        case 'Enter':
        case ' ':
          e.preventDefault();
          toggleAccordion(this);
          break;
        case 'ArrowUp':
        case 'ArrowLeft':
          e.preventDefault();
          focusPreviousButton(this);
          break;
        case 'ArrowDown':
        case 'ArrowRight':
          e.preventDefault();
          focusNextButton(this);
          break;
        case 'Home':
          e.preventDefault();
          focusFirstButton();
          break;
        case 'End':
          e.preventDefault();
          focusLastButton();
          break;
      }
    });

    // Manejar clics (ratón/toque)
    button.addEventListener('click', function() {
      toggleAccordion(this);
    });
  });

  // Función para alternar el acordeón
  function toggleAccordion(button) {
    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    const groupName = button.querySelector('h3').textContent.trim();
    const content = document.querySelector(`[data-filter-group="${groupName}"]`);

    // Actualizar estado ARIA
    button.setAttribute('aria-expanded', !isExpanded);

    // Alternar clases visuales
    button.classList.toggle('productgrid--sidebar-button-active');

    // Alternar el contenido asociado
    if (content) {
      content.classList.toggle('filter-group-active');
      content.setAttribute('aria-expanded', !isExpanded);
      content.setAttribute('data-accordion-state', 
        content.getAttribute('data-accordion-state') === 'open' ? 'closed' : 'open');
    }

    // Feedback visual para foco
    button.style.outline = '2px solid #005fcc';
    setTimeout(() => {
      button.style.outline = '';
    }, 300);
  }

  // Funciones de navegación por teclado
  function focusPreviousButton(currentButton) {
    const buttons = Array.from(document.querySelectorAll('[data-filter-group-trigger]'));
    const index = buttons.indexOf(currentButton);
    if (index > 0) buttons[index - 1].focus();
  }

  function focusNextButton(currentButton) {
    const buttons = Array.from(document.querySelectorAll('[data-filter-group-trigger]'));
    const index = buttons.indexOf(currentButton);
    if (index < buttons.length - 1) buttons[index + 1].focus();
  }

  function focusFirstButton() {
    const buttons = document.querySelectorAll('[data-filter-group-trigger]');
    if (buttons.length) buttons[0].focus();
  }

  function focusLastButton() {
    const buttons = document.querySelectorAll('[data-filter-group-trigger]');
    if (buttons.length) buttons[buttons.length - 1].focus();
  }
}

// Verificar si el sidebar ya está en el DOM al cargar la página
document.addEventListener('DOMContentLoaded', function() {
  if (document.querySelector('[data-filter-group-trigger]')) {
    initSidebarAccessibility();
  } else {
    // Si no está, observar cambios en el DOM
    const observer = new MutationObserver(function(mutations) {
      if (document.querySelector('[data-filter-group-trigger]')) {
        initSidebarAccessibility();
        observer.disconnect(); // Dejar de observar después de aplicar
      }
    });

    // Observar cambios en todo el body (incluyendo subárbol)
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
});



















// add aria page to current selected li
document.addEventListener('DOMContentLoaded', function() {
  const filterItems = document.querySelectorAll('.filter-item');
  
  filterItems.forEach(item => {
    const isActive = item.getAttribute('data-filter-active') === 'true';
    
    if (isActive) {
      const link = item.querySelector('a');
      
      if (link) {
        // add aria-current="page" to link active
        link.setAttribute('aria-current', 'page');
        
        const checkbox = item.querySelector('.filter-icon--checkbox');
        if (checkbox) {
          checkbox.setAttribute('aria-checked', 'true');
          checkbox.setAttribute('role', 'checkbox');
        }
      }
    } else {
      const link = item.querySelector('a');
      if (link && link.hasAttribute('aria-current')) {
        link.removeAttribute('aria-current');
      }
      

      const checkbox = item.querySelector('.filter-icon--checkbox');
      if (checkbox) {
        checkbox.setAttribute('aria-checked', 'false');
        checkbox.setAttribute('role', 'checkbox');
      }
    }
  });
});




//change li to h3 in product details
/* document.addEventListener('DOMContentLoaded', function() {
console.log('in');
  function applyAccessibilityFix() {
    const detailLists = document.querySelectorAll('.ml-pdp-details');
    
    if (detailLists.length === 0) {
      console.log('Elements no found, reinit...');
      setTimeout(applyAccessibilityFix, 500);
      return;
    }
    
    detailLists.forEach(list => {
      if (list.dataset.accessibilityFixed === 'true') {
        return;
      }
      
      list.dataset.accessibilityFixed = 'true';
      
      const headingItem = list.querySelector('.ml-pdp-detail__heading');
      
      if (headingItem) {
        const heading = document.createElement('h3');
        heading.textContent = headingItem.textContent;
        heading.className = 'ml-pdp-detail-heading ' + (headingItem.className || '');
        
        Array.from(headingItem.attributes).forEach(attr => {
          if (attr.name !== 'class') { 
            heading.setAttribute(attr.name, attr.value);
          }
        });
        
        const container = document.createElement('ul');
        container.className = 'ml-pdp-details';
        
        container.appendChild(heading);
        
        Array.from(list.children).forEach(child => {
          if (!child.classList.contains('ml-pdp-detail__heading')) {
            container.appendChild(child.cloneNode(true));
          }
        });
        
        list.parentNode.insertBefore(container, list);
        list.remove();
        
        console.log('Section complete:', heading.textContent);
      }
    });
    
    if (detailLists.length > 0) {
      observer.disconnect(); 
    }
  }
  
  const observer = new MutationObserver(function(mutations) {
    const hasRelevantChanges = mutations.some(mutation => {
      return Array.from(mutation.addedNodes).some(node => {
        return node.nodeType === 1 && (node.classList.contains('ml-pdp-details') || 
               node.querySelector('.ml-pdp-details'));
      });
    });
    
    if (hasRelevantChanges) {
      applyAccessibilityFix();
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: false,
    characterData: false
  });
  
  applyAccessibilityFix();
}); */
  
document.addEventListener('DOMContentLoaded', function () {
  // Main function to fix detail headings
  function fixDetailHeadings() {
    document.querySelectorAll('ul.ml-pdp-details').forEach((ul) => {
      // Avoid processing the same element more than once
      if (ul.dataset.accessibilityFixed === 'true') return;

      // Look for the <li> that should become a <h3>
      const headingLi = ul.querySelector('li.ml-pdp-detail__heading');
      if (!headingLi) return;

      // Create a new <h3> element with the same content
      const h3 = document.createElement('h3');
      h3.className = 'ml-pdp-detail__heading';
      h3.textContent = headingLi.textContent;

      // Insert the new heading before the <ul>
      ul.parentNode.insertBefore(h3, ul);

      // Remove the original <li> heading from inside the <ul>
      headingLi.remove();

      // Mark this list as processed
      ul.dataset.accessibilityFixed = 'true';
    });
  }

  // Retry mechanism to handle late-loading DOM content
  let retries = 0;
  function tryFix() {
    fixDetailHeadings();
    if (++retries < 6) setTimeout(tryFix, 400);
  }

  tryFix();
});


/* A11Y PASS 2026 (CL-05..CL-11) */
function a11yReady(e){"loading"===document.readyState?document.addEventListener("DOMContentLoaded",e):e()}a11yReady(function(){var e=document.querySelector("[data-product-gallery]");if(e){var t=null,a=!1,r={subtree:!0,childList:!0,attributes:!0,attributeFilter:["data-gallery-selected","src","class"]};new MutationObserver(l).observe(e,r);var i=document.querySelector(".pswp");i&&new MutationObserver(l).observe(i,r),o()}function n(e){return(e||"").split("?")[0].split("/").pop().replace(/_(\d+x\d*|x\d+|\{size\})(?=\.)/,"").replace(/\.[a-z0-9]+$/i,"")}function o(){var a=function(){var t=Array.prototype.slice.call(e.querySelectorAll("figure[data-gallery-figure]")).map(function(e,t){var a=e.querySelector("img");return a&&!a.hasAttribute("data-a11y-alt")&&a.setAttribute("data-a11y-alt",a.getAttribute("alt")||""),{fig:e,img:a,pos:t+1,base:a?a.getAttribute("data-a11y-alt"):"",type:e.getAttribute("data-media-type")||"image",zoom:n(e.getAttribute("data-zoom"))}}),a={};return t.forEach(function(e){a[e.base]=(a[e.base]||0)+1}),t.forEach(function(e){e.label=(e.base||"Product image")+(a[e.base]>1||!e.base?" – image "+e.pos+" of "+t.length:"")}),t}(),r=a.length,i={},o={};a.forEach(function(e){i[e.fig.getAttribute("data-gallery-index")]=e,e.zoom&&(o[e.zoom]=e),e.img&&e.img.getAttribute("alt")!==e.label&&e.img.setAttribute("alt",e.label)}),document.querySelectorAll(".product-gallery--media-thumbnail[data-gallery-index]").forEach(function(e){var t=i[e.getAttribute("data-gallery-index")];if(t){var a="Show "+(/video/.test(t.type)?"video":"model"===t.type?"3D model":"image")+" "+t.pos+" of "+r+": "+(t.base||"product");e.getAttribute("aria-label")!==a&&e.setAttribute("aria-label",a);var n=e.querySelector("img");n&&""!==n.getAttribute("alt")&&n.setAttribute("alt","");var o="true"===e.getAttribute("data-gallery-selected");o&&"true"!==e.getAttribute("aria-current")&&e.setAttribute("aria-current","true"),!o&&e.hasAttribute("aria-current")&&e.removeAttribute("aria-current")}});var l=document.querySelector(".pswp");if(l){l.querySelectorAll("img.pswp__img").forEach(function(e){var t=e.classList.contains("pswp__img--placeholder")?"":(o[n(e.getAttribute("src"))]||{}).label||"Product image";e.getAttribute("alt")!==t&&e.setAttribute("alt",t)}),t||((t=document.createElement("div")).id="a11y-zoom-status",t.className="visually-hidden",t.setAttribute("aria-live","polite"),l.appendChild(t));var u=l.querySelector('.product-gallery--media-thumbnail[data-gallery-selected="true"]'),d=u&&i[u.getAttribute("data-gallery-index")],s=l.classList.contains("pswp--open")&&d?"Showing image "+d.pos+" of "+r+": "+(d.base||"product"):"";t.textContent!==s&&(t.textContent=s)}}function l(){a||(a=!0,requestAnimationFrame(function(){a=!1,o()}))}}),a11yReady(function(){document.querySelectorAll(".js-ml-show-more").forEach(function(e,t){var a=e.previousElementSibling,r=a&&a.querySelector(".js-ml-excerpt");function i(){e.setAttribute("aria-expanded",r.classList.contains("ml-excerpt-visible")?"true":"false")}r&&(r.id||(r.id="ml-pdp-details-"+(t+1)),e.setAttribute("aria-controls",r.id),i(),new MutationObserver(i).observe(r,{attributes:!0,attributeFilter:["class"]}),e.addEventListener("keydown",function(t){" "!==t.key&&"Spacebar"!==t.key||(t.preventDefault(),e.click())}))})}),a11yReady(function(){function e(){document.querySelectorAll(".site-header-cart--button").forEach(function(e){var t=e.querySelector("[data-header-cart-count]"),a=e.querySelector(".visually-hidden");if(t&&a){"true"!==t.getAttribute("aria-hidden")&&t.setAttribute("aria-hidden","true");var r=parseInt(t.getAttribute("data-header-cart-count"),10)||0,i="View cart, "+r+(1===r?" item":" items");a.textContent!==i&&(a.textContent=i)}})}e(),new MutationObserver(e).observe(document.body,{subtree:!0,childList:!0,attributes:!0,attributeFilter:["data-header-cart-count"]})}),a11yReady(function(){var e=window.jQuery;if(e&&e.datepicker){var t=e("#ml_ship_date");if(t.length&&t.hasClass("hasDatepicker")){var a=e.datepicker,r=t[0],i="mm/dd/yy",n=t.closest(".form-field");n.append('<span id="ml_ship_date_hint" class="visually-hidden">Type a date as MM/DD/YYYY, or use the calendar: arrow keys move between days, Page Up and Page Down change the month, Enter selects, Escape closes. Available Monday, Tuesday, Wednesday, Friday and Saturday, 2 to 30 days from today.</span><span id="ml_ship_date_live" class="visually-hidden" aria-live="polite"></span>'),n.after('<p id="ml_ship_date_error" class="ml-date-error" role="alert" hidden></p>'),t.attr({"aria-describedby":"ml_ship_date_hint ml_ship_date_error",autocomplete:"off"});var o=document.getElementById("ml_ship_date_live"),l=document.getElementById("ml_ship_date_error");t.datepicker("option","beforeShow",function(){setTimeout(function(){s("Calendar open. "+y(c()))},150)}),t.on("keydown.a11y",function(e){if(a._datepickerShowing&&a._curInst&&a._curInst.input&&a._curInst.input[0]===r){if(!e.ctrlKey&&!e.metaKey){var t={ArrowLeft:-1,ArrowRight:1,ArrowUp:-7,ArrowDown:7}[e.key];"Home"===e.key&&(t=-(c().getDay()+6)%7),"End"===e.key&&(t=6-(c().getDay()+6)%7),void 0!==t?(e.preventDefault(),0!==t&&a._adjustDate(r,t,"D"),s(y(c()))):"PageUp"===e.key||"PageDown"===e.key?setTimeout(function(){s(y(c()))},0):"Enter"!==e.key||d(c())||s("That date is not available. Choose another date.")}}else"ArrowDown"===e.key&&e.altKey&&(e.preventDefault(),a._showDatepicker(r))}),t.on("change.a11y",function(){var n=e.trim(r.value),o=null;if(!n)return l.hidden=!0,void r.removeAttribute("aria-invalid");try{o=a.parseDate(i,n)}catch(e){o=null}if(!o||!d(o))return l.textContent="Please enter an available date as MM/DD/YYYY: Monday, Tuesday, Wednesday, Friday or Saturday, 2 to 30 days from today.",l.hidden=!1,void r.setAttribute("aria-invalid","true");l.hidden=!0,l.textContent="",r.removeAttribute("aria-invalid");var u=a.formatDate(i,o);t.attr("value")!==u&&a._selectDate(r,u)}),t.datepicker("option","onClose",function(){setTimeout(function(){var t=document.activeElement;t&&t!==document.body&&!e(t).closest("#ui-datepicker-div").length||(a._lastInput=r,r.focus(),setTimeout(function(){a._lastInput=null},0))},0)})}}function u(){return a._getInst(r)}function d(e){var r=u(),i=a._getMinMaxDate(r,"min"),n=a._getMinMaxDate(r,"max"),o=t.datepicker("option","beforeShowDay");return(!i||e>=i)&&(!n||e<=n)&&(!o||o(e)[0])}function s(e){o.textContent="",setTimeout(function(){o.textContent=e},40)}function c(){var e=u();return new Date(e.selectedYear,e.selectedMonth,e.selectedDay)}function y(e){return a.formatDate("DD, MM d, yy",e)+(d(e)?", available":", not available")}});
